module.exports = __webpack_public_path__ + "static/img/dragable-smaller.5e69610.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dragable-smaller.svg
// module id = 288
// module chunks = 0